import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f90715a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title sub-title" }, "オンライン資料に関する項目", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        _createVNode(_component_ConfirmInput, {
          name: '題名',
          value: _ctx.state.name,
          class: _normalizeClass('title')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '版表示',
          value: _ctx.state.edition,
          class: _normalizeClass('edition')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '巻号',
          value: _ctx.state.volume,
          class: _normalizeClass('volume')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '作成者',
          value: _ctx.state.author,
          class: _normalizeClass('author')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '出版者',
          value: _ctx.state.publisher,
          class: _normalizeClass('publisher')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: '出版日',
          value: `${_ctx.state.publishYear} ${_ctx.state.publishFrom} ～ ${_ctx.state.publishTo}`,
          class: _normalizeClass('date')
        }, null, 8, ["value"]),
        _createVNode(_component_ConfirmInput, {
          name: 'コード情報',
          value: `${_ctx.state.codeType} ${_ctx.state.code}`,
          class: _normalizeClass('code')
        }, null, 8, ["value"])
      ])
    ])
  ]))
}